import React from 'react';
import { Modal, Button, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';

const IdleTimeOutModal = ({ showModal, handleClose,handleClose1 }) => {

    return (
        <Modal isOpen={showModal} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>You Have Been Idle!</ModalHeader>
            <ModalBody>You Will Get Timed Out in 15 Minutes. You want to stay?</ModalBody>
            <ModalFooter>
                <Button variant="danger" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleClose1}>
                    Stay
                </Button>
            </ModalFooter>
        </Modal>
    )
}
IdleTimeOutModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleClose1:PropTypes.func.isRequired
}
export default IdleTimeOutModal